import { Texture, TilingSprite } from "pixi.js"
import nearsvg from "./assets/Planets.svg"
import farpng from "./assets/Little-stars.png"

const nearBackground = Texture.from(nearsvg)
export const near = new TilingSprite(nearBackground, window.innerWidth, window.innerHeight)
near.position.set(0, 0)

const farBackground = Texture.from(farpng)
export const far = new TilingSprite(farBackground, window.innerWidth, window.innerHeight)
far.position.set(0, 0)
